const ChangeCookiePreference = (accept: boolean): void => {
    const status = accept ? 'granted' : 'denied';
    localStorage.setItem('allowGA', status);
}

export default ChangeCookiePreference;